"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var scales_1 = require("../constants/scales");

var directionalPropsToStylesUtil_1 = require("../utils/directionalPropsToStylesUtil");

var propToStyleMap = {
  m: 'margin',
  mt: 'margin-top',
  mr: 'margin-right',
  mb: 'margin-bottom',
  ml: 'margin-left',
  mx: ['margin-left', 'margin-right'],
  my: ['margin-top', 'margin-bottom'],
  p: 'padding',
  pt: 'padding-top',
  pr: 'padding-right',
  pb: 'padding-bottom',
  pl: 'padding-left',
  px: ['padding-left', 'padding-right'],
  py: ['padding-top', 'padding-bottom']
}; // TODO: Support responsive spacing (maybe optional?)

var space = function space(props) {
  if (props === void 0) {
    props = {};
  }

  return directionalPropsToStylesUtil_1.default(props, propToStyleMap, scales_1.fixedSpacing);
};

exports.default = space;